
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sugar-crm",
      function () {
        return require("private-next-pages/destinations/sugar-crm.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sugar-crm"])
      });
    }
  